
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ItemModelUtil } from '../model-utils/item-model-util';

@Component({})
export default class NavigationDots extends Vue {
  @Prop(Number) public index!: number;
  @Prop(Number) public size!: number;

  public windowSize = 10;

  public goToRelativePage(offset: number) {
    this.$emit('go-to-page', '=' + (this.index + offset));
  }

  get numDots() {
    const lastPageSize = this.size % this.windowSize;
    if (this.index > this.size - lastPageSize - 1) {
      return lastPageSize;
    } else {
      return this.windowSize;
    }
  }

  get numBefore() {
    return this.index % this.windowSize;
  }

  get numAfter() {
    const inPageIndex = this.index % this.windowSize;
    if (inPageIndex == this.numDots - 1) {
      return 0;
    }
    return this.numDots - inPageIndex - 1;
  }
}
